import React, { useContext, useState } from "react";
import { Card, Input, Row, Col, Divider, Tooltip, Checkbox } from "antd";
import { FiInfo } from "react-icons/fi";
import formatIndianNumber from "../../../../../utils/formatIndianNumber";
import mainContext from "../context/MainContext/mainContext";
import { useSearchParams } from "react-router-dom";

const TotalProductionCost = ({
  selectedInventories,
  totalInvoices,
  manualPrintingCharge,
  manualMountingCharge,
  onPrintingChargeChange,
  onMountingChargeChange,
  includedSubBDFPrintingCharge = 0,
  includedSubBDFMountingCharge = 0,
  isPrintingChargeSelected = true,
  isMountingChargeSelected = true,
  onPrintingChargeSelectionChange,
  onMountingChargeSelectionChange,
  duePrintingAmount = 0,
  dueMountingAmount = 0,
  isSplitBilling = false,
}) => {
  const { justView } = useContext(mainContext);
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  const getTotalCharges = () => {
    if (!selectedInventories?.length)
      return { printingCharge: 0, mountingCharge: 0 };

    // ✅ Always calculate if tab=2 OR if no invoices exist
    if (tab === "2" || totalInvoices === 0) {
      return selectedInventories.reduce(
        (acc, inv) => {
          acc.printingCharge += Number(inv.printingCharge) || 0;
          acc.mountingCharge += Number(inv.mountingCharge) || 0;
          return acc;
        },
        { printingCharge: 0, mountingCharge: 0 }
      );
    }

    return { printingCharge: 0, mountingCharge: 0 };
  };

  const calculatedCharges = getTotalCharges();

  // Manual overrides all. Otherwise: base = due (if any) else line-calculated; then add included Sub-BDF when checked.
  const dueP = Number(duePrintingAmount) || 0;
  const dueM = Number(dueMountingAmount) || 0;
  // Split BDF rule: due values are authoritative even when they are 0 (API may explicitly send 0).
  const basePrinting = isSplitBilling ? dueP : dueP > 0 ? dueP : calculatedCharges.printingCharge;
  const baseMounting = isSplitBilling ? dueM : dueM > 0 ? dueM : calculatedCharges.mountingCharge;

  const printingCharge =
    manualPrintingCharge !== undefined
      ? manualPrintingCharge
      : basePrinting + includedSubBDFPrintingCharge;

  const mountingCharge =
    manualMountingCharge !== undefined
      ? manualMountingCharge
      : baseMounting + includedSubBDFMountingCharge;

  // Only include charges in total if they are selected
  const selectedPrintingCharge = isPrintingChargeSelected ? printingCharge : 0;
  const selectedMountingCharge = isMountingChargeSelected ? mountingCharge : 0;
  const totalProductionCost = selectedPrintingCharge + selectedMountingCharge;

  // Handle input changes
  const handlePrintingChargeChange = (e) => {
    const value = e.target.value.replace(/,/g, ""); // Remove commas
    const numericValue = value === "" ? 0 : Number(value);
    onPrintingChargeChange(numericValue);
  };

  const handleMountingChargeChange = (e) => {
    const value = e.target.value.replace(/,/g, ""); // Remove commas
    const numericValue = value === "" ? 0 : Number(value);
    onMountingChargeChange(numericValue);
  };

  // Dropdown content
  return (
    <Card style={{ border: "1px solid lightgrey", marginLeft: "4rem" }}>
      <Row>
        <Col span={2}>
          <Checkbox
            checked={isPrintingChargeSelected}
            onChange={(e) => onPrintingChargeSelectionChange(e.target.checked)}
            disabled={justView}
          />
        </Col>
        <Col span={10}>
          <div style={{ display: "flex", alignItems: "center" }}>
            Printing Charge
            {includedSubBDFPrintingCharge > 0 && (
              <Tooltip title="Includes Sub BDF printing charges">
                <FiInfo style={{ marginLeft: "5px", color: "#1890ff" }} />
              </Tooltip>
            )}
          </div>
        </Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Input
            readOnly={justView || !isPrintingChargeSelected}
            // readOnly={true}
            value={formatIndianNumber(printingCharge)}
            onChange={handlePrintingChargeChange}
            style={{
              backgroundColor: !isPrintingChargeSelected ? "#f5f5f5" : "white",
              opacity: !isPrintingChargeSelected ? 0.6 : 1,
            }}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: "10px" }}>
        <Col span={2}>
          <Checkbox
            checked={isMountingChargeSelected}
            onChange={(e) => onMountingChargeSelectionChange(e.target.checked)}
            disabled={justView}
          />
        </Col>
        <Col span={10}>
          <div style={{ display: "flex", alignItems: "center" }}>
            Mounting Charge
            {includedSubBDFMountingCharge > 0 && (
              <Tooltip title="Includes Sub BDF mounting charges">
                <FiInfo style={{ marginLeft: "5px", color: "#1890ff" }} />
              </Tooltip>
            )}
          </div>
        </Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Input
            value={formatIndianNumber(mountingCharge)}
            readOnly={justView || !isMountingChargeSelected}
            // readOnly={true}
            onChange={handleMountingChargeChange}
            style={{
              backgroundColor: !isMountingChargeSelected ? "#f5f5f5" : "white",
              opacity: !isMountingChargeSelected ? 0.6 : 1,
            }}
          />
        </Col>
      </Row>
      <Divider />
      <Row style={{ fontWeight: "bold", marginTop: "10px" }}>
        <Col span={12}>Total Production Cost</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          {formatIndianNumber(totalProductionCost)}
          {/* Format the total with commas */}
        </Col>
      </Row>
    </Card>
  );

  // return (
  //   <Dropdown
  //     overlay={dropdownContent}
  //     trigger={["click"]}
  //     visible={visible}
  //     onVisibleChange={handleVisibleChange}
  //     placement="bottomLeft"
  //   >
  //     <Button className="totalProductionCost-btn">
  //       Total Production Cost:
  //       <span style={{marginLeft:"4rem"}}>
  //         {formatIndianNumber(billingData?.printingCharge+billingData?.mountingCharge)}
  //         <IoIosArrowUp style={{ marginLeft: "1rem" }} />
  //       </span>
  //     </Button>
  //   </Dropdown>
  // );
};

export default TotalProductionCost;
